import { TerminalDetails } from '../../../../../shared/entities/terminal';
import { DetailsPanelGroupCollapseState } from '../../../../../store/ui/reducer';
import { isOnline } from '../../../../../utils/ConnectionStatusUtils';
import { toFixedValueFormatter } from '../../../../../utils/StringUtils';
import CollapseGroup from '../../../../common/collapse_group/CollapseGroup';
import CollapseGroupItem from '../../../../common/collapse_group/CollapseGroupItem';

interface CollapseGroupItemTerminalStatusProps {
  isOffline: boolean;
  tailDetailsPanelTerminal?: TerminalDetails;
  detailsPanelGroupCollapseState: DetailsPanelGroupCollapseState;
  toggleGroupCollapsed: (groupName: keyof DetailsPanelGroupCollapseState) => void;
  children?: React.ReactNode;
}
const CollapseGroupItemTerminalStatus = (props: CollapseGroupItemTerminalStatusProps) => {
  const { children, isOffline, tailDetailsPanelTerminal, detailsPanelGroupCollapseState, toggleGroupCollapsed } = props;
  return (
    <CollapseGroup
      data-test="terminal__status__collapse__group__header--terminal__status"
      collapseButtonClicked={() => {
        toggleGroupCollapsed('aircraftStatusGroupOpened');
      }}
      open={detailsPanelGroupCollapseState.aircraftStatusGroupOpened}
      title="Terminal Status"
    >
      <div className={(isOffline && tailDetailsPanelTerminal?.networkGroup != "GX")  ? 'tail__details_faded_wrapper' : ''}>
        <CollapseGroupItem
          id="latitude"
          label="Latitude"
          value={tailDetailsPanelTerminal ? tailDetailsPanelTerminal.latitudeDeg : null}
          valueFormatter={toFixedValueFormatter(4, '°')}
        />
        <CollapseGroupItem
          id="longitude"
          label="Longitude"
          value={tailDetailsPanelTerminal ? tailDetailsPanelTerminal.longitudeDeg : null}
          valueFormatter={toFixedValueFormatter(4, '°')}
        />
        {children}
      </div>
    </CollapseGroup>
  );
};

export default CollapseGroupItemTerminalStatus;
